import { Card, CardContent } from "@mui/material";

const Journey = () => {
  return (
    <div className="flex flex-col text-white">
      <div className="flex flex-row mx-auto text-3xl md:text-5xl font-HNmed mb-8">
        Our&nbsp;
        <span className="text-[#00B4AE] underline decoration-[#D9A900] underline-offset-8 decoration-2">
          Journey
        </span>
      </div>
      <div className="flex flex-col md:flex-row w-full items-center">
        <div className="flex flex-col w-full md:w-1/3">
          <div className="flex flex-col rounded-[40px] bg-[#D9D9D9] text-[#423400] p-6 m-5">
            <div className="text-center md:text-right font-HNbold text-2xl md:text-5xl pb-3">
              Mission
            </div>
            <div className="text-justify font-HNmed text-[#423400b3]">
              Our mission is to provide high-quality, reliable packaging
              solutions by utilizing advanced technologies and sustainable
              practices. We aim to foster long-term partnerships with our
              clients, ensuring their products are packaged with care and
              precision, while continually striving to reduce our environmental
              footprint.
            </div>
          </div>
          <div className="flex flex-col rounded-[40px] bg-[#D9D9D9] text-[#423400] p-6 m-5 mt-0">
            <div className="text-center md:text-right font-HNbold text-2xl md:text-5xl pb-3">
              Vision
            </div>
            <div className="text-justify font-HNmed text-[#423400b3]">
              To be a global leader in sustainable packaging solutions,
              leveraging cutting-edge technology to deliver innovative,
              eco-friendly products that exceed customer expectations and
              contribute to a greener planet.
            </div>
          </div>
        </div>
        <div className="flex flex-col w-[80%] md:w-1/3 ">
          <img
            height={"100%"}
            className="rounded-[45px]"
            src={require("../../assets/images/machineBig.png")}
            alt="Machine"
          />
        </div>

        <div className="flex flex-col md:w-1/3 mx-4 bg-[#D9A900]  rounded-[40px] mt-4">
          <Card
            sx={{
              margin: 4,
              borderRadius: 5,
              backgroundColor: "#F9C200",

              padding: 0,
            }}
          >
            <CardContent
              sx={{ padding: 0, "&:last-child": { paddingBottom: 0 } }}
            >
              <div className="flex flex-col justify-around text-[#423400] my-1 p-3">
                <div className="text-center md:text-right font-HNbold text-2xl md:text-5xl pb-4">
                  Origin
                </div>
                <div className="md:text-justify font-HNmed text-[#423400b3]">
                  Founded as part of V Group Industries, V&nbsp;Pack has its
                  roots in the visionary leadership of K T Varghese. Initially
                  established to address the growing demand for high-quality
                  packaging, V&nbsp;Pack has grown significantly since its
                  inception. The company is currently led by Felix Varghese,
                  Founder, and Abee Felix, Managing Partner. Their combined
                  expertise and dedication have propelled V&nbsp;Pack to the
                  forefront of the packaging industry. Under their guidance, the
                  company has maintained its focus on innovation and
                  sustainability, transforming into a key player in the global
                  packaging market. Today, V&nbsp;Pack continues to thrive,
                  serving major brands with top-tier packaging solutions and a
                  commitment to environmental responsibility.
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className="flex flex-col md:flex-row w-full justify-evenly mt-4">
        <div className="flex flex-col w-[80%] md:w-[45%] mx-auto mb-2">
          <img
            className="rounded-[30px] md:rounded-[40px]"
            src={require("../../assets/images/machineBigbw.png")}
            alt="Machine"
          />
        </div>
        <div className="flex flex-col w-[80%] md:w-[45%] mx-auto">
          <img
            className="rounded-[30px] md:rounded-[40px]"
            src={require("../../assets/images/factory.png")}
            alt="Machine"
          />
        </div>
      </div>
    </div>
  );
};

export default Journey;
